import type { AxiosError } from 'axios';

/** Pull the API's human-readable error message out of an Axios error, with a fallback. */
export function errMessage(e: unknown, fallback = 'Something went wrong'): string {
  return (e as AxiosError<{ error?: { message?: string } }>)?.response?.data?.error?.message ?? fallback;
}
